import React, { Component } from 'react'
import DatePicker from 'react-datepicker'
import withStyles from 'isomorphic-style-loader/lib/withStyles'
import dtPickerStyle from 'react-datepicker/dist/react-datepicker.css'

import { calendarContainer } from './style'

class Calendar extends Component {
  state = {
    show: false,
  }

  render() {
    return (
      <div className={calendarContainer}>
        <DatePicker
          id={this.props.id}
          className={this.props.className}
          popperModifiers={this.props.popperModifiers}
          popperClassName={this.props.popperClassName}
          selected={this.props.selected}
          onChange={this.props.onChange}
          onChangeRaw={this.props.onChangeRaw}
          isError={this.props.isError}
          placeholder={this.props.placeholder}
          label={this.props.label}
          placeholderText={this.props.placeholderText}
          dateFormat={this.props.dateFormat}
          customInput={this.props.customInput}
          useWeekdaysShort={true}
          showMonthDropdown
          showYearDropdown
          disabled={this.props.disabled}
          peekNextMonth={this.props.peekNextMonth}
          inline={this.props.inline}
          maxDate={this.props.maxDate}
          scrollableYearDropdown
          yearDropdownItemNumber={200}
        // dropdownMode="select"
        // fixedHeight
        // showWeekNumbers
        />
      </div>
    )
  }
}

export default withStyles(dtPickerStyle)(Calendar)
